module.exports = __webpack_public_path__ + "static/media/hall-P11-2026.6d9b622d.svg";